export var searchActionType;
(function (searchActionType) {
    searchActionType["UPDATESEARCH"] = "UPDATE_SEARCH";
    searchActionType["ADD_LIST_POST"] = "ADD_LIST_POST";
    searchActionType["ADD_POST"] = "ADD_POST";
    searchActionType["CLEAR"] = "CLEAR";
    searchActionType["ADD_FILTERM"] = "ADD_FILTERM";
})(searchActionType || (searchActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/searchActionType.ts
// module id = 401
// module chunks = 50